export default function setCountryAction(country) {
    return {
        type: 'SET_COUNTRY',
        payload: country
    }
}